/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { type BillingSettingsInput } from '@therapy/shared-validators';

import { apiClient } from './client.js';

/** Per-clinic billing & rules settings (CR foundation, S2). */
export type BillingSettings = BillingSettingsInput;

export const billingSettingsApi = {
  async get(): Promise<BillingSettings> {
    const { data } = await apiClient.get<BillingSettings>('/finance/settings');
    return data;
  },
  async update(input: BillingSettings): Promise<BillingSettings> {
    const { data } = await apiClient.put<BillingSettings>('/finance/settings', input);
    return data;
  },
};
